export const getProgressPrecentage = (decidedCount, totalCount) =>
  totalCount !== 0 ? Math.floor((decidedCount / totalCount) * 100) : 0;

export const getAverageScore = (decidedCount, totalScore) =>
  decidedCount === 0 ? 0 : (totalScore / decidedCount).toFixed(0);

export const getProgressPercentageDouble = (decidedCount, totalCount) =>
  totalCount !== 0 ? ((decidedCount / totalCount) * 100).toFixed(2) : 0;
